import { TextField } from "@king-ict/eupisi-ui/components";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { ProgramCodeBook, ProgramType, ProgramTypeCodeBook } from "../../models/Program";
import { ProgramRequestData } from "../../models/ProgramRequest";
import styles from "./ProgramRequestEdit.module.scss";

interface Props {
    programData: ProgramCodeBook;
}

/**
 * Renders 3 rows of readonly qualification, hkoLevel, 
 * sector, and profession info.
 * @param param0 
 * @returns 
 */
export function ExpertiseExistingProgramInfo({
    programData
}: Props) {
    const { t } = useTranslation();    

    return (
      <>
        <Row className={styles.rowSpacing}>
          <Col md={4}>
            <TextField
              plaintext
              label={t("request.qualification")}
              value={programData.qualificationType}
            />
          </Col>
          <Col md={4}>
            <TextField
              plaintext
              label={t("request.hkoLevel")}
              readonly
              value={programData.hkoLevelName}
            />
          </Col>
        </Row>
            <Row className={styles.rowSpacing}>
                <Col md={4}>
                    <TextField
                        plaintext
                        label={t("common.educationSector")}
                        value={programData.educationSectorName}
                    />
                </Col>
                <Col md={4}>
                    <TextField
                        plaintext
                        label={t("common.educationSubSector")}
                        readonly
                        value={programData.educationSubSectorName}
                    />
                </Col>
            </Row>
            <Row className={styles.rowSpacing}>
                <Col md={4}>
                    <TextField
                        plaintext
                        label={programData.programTypeId === ProgramType.NewVocationalCurriculum ? t("request.newVocationCurriculumProffesion") : t("common.profession")}
                        readonly
                        value={programData.professionName}
                    />
                </Col>
            </Row>
        </>
    );
}